"use strict";

/**
 * Zvýraznění článků podle výběru krajů (localStorage regionCheckboxStates).
 * Na window kvůli lazyload.js / user.js (ES moduly) a stránkám bez regional-content wrapperu.
 * Logika odpovídá regional-content.js — při změně tam synchronizovat.
 */

// Titulka (hero + 2 vedle, mřížka 4 sloupce vč. „Zobrazit více“) a výpisy (#604).
const BI_REGION_ARTICLES =
  ".article-list__wrapper_homepage article, .article-list__wrapper_second--4col article, .article-list__content article";
const BI_REGION_ARTICLES_HIGHLIGHTED =
  ".article-list__wrapper_homepage article.highlighted, .article-list__wrapper_second--4col article.highlighted, .article-list__content article.highlighted";
function biGetSelectedRegionNamesFromStorage() {
  const storedState = JSON.parse(localStorage.getItem("regionCheckboxStates") || "{}");
  return Object.keys(storedState).filter((region) => storedState[region]);
}

function biClearArticleRegionClasses() {
  const articles = document.querySelectorAll(BI_REGION_ARTICLES);
  articles.forEach((article) => {
    article.classList.remove("highlighted");
    const termAttr = article.dataset.krajTermNames;
    if (!termAttr) return;
    termAttr
      .split(",")
      .map((name) => name.trim())
      .forEach((region) => {
        article.classList.remove(region);
      });
  });
}

function biUpdateRegionalContentCounters() {
  const count = document.querySelectorAll(BI_REGION_ARTICLES_HIGHLIGHTED).length;
  document.querySelectorAll(".regional-content-counter").forEach((counter) => {
    counter.textContent = count;
  });
}

function highlightArticlesByRegion() {
  const selectedRegions = biGetSelectedRegionNamesFromStorage();
  const articles = document.querySelectorAll(BI_REGION_ARTICLES);

  biClearArticleRegionClasses();

  if (!selectedRegions.length || !articles.length) {
    biUpdateRegionalContentCounters();
    return;
  }

  articles.forEach((article) => {
    const termAttr = article.dataset.krajTermNames;
    if (!termAttr) return;
    const articleRegions = termAttr.split(",").map((name) => name.trim());
    const matchingRegions = selectedRegions.filter((region) =>
      articleRegions.includes(region)
    );
    if (matchingRegions.length > 0) {
      article.classList.add("highlighted");
      matchingRegions.forEach((region) => {
        article.classList.add(region);
      });
    }
  });

  biUpdateRegionalContentCounters();
}

window.highlightArticlesByRegion = highlightArticlesByRegion;
